/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserActionLogDto } from '../../models/user-action-log-dto';

export interface UserActionLogControllerDelete$Params {
  id: string;
}

export function userActionLogControllerDelete(http: HttpClient, rootUrl: string, params: UserActionLogControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<UserActionLogDto>> {
  const rb = new RequestBuilder(rootUrl, userActionLogControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserActionLogDto>;
    })
  );
}

userActionLogControllerDelete.PATH = '/api/user-action-log/{id}';
